import { compact } from 'lodash';
import DeviceScreen from 'lib/DeviceScreen';

export default class {
  constructor(attributes = {}) {
    this.attributes = attributes;
  }

  get ensightenProperties() {
    const { type, focus } = this.attributes;

    return {
      site: `${this.prefix}${this.condition}.${this.source}`,
      adunit: compact([type, focus])
        .map((segment) => {
          return `/${segment}`;
        })
        .join(),
    };
  }

  get prefix() {
    return this.attributes.prefix || '/36117602/jam.alst.';
  }

  get source() {
    return this.attributes.source || (DeviceScreen.isMobile() ? 'mob' : 'dfp');
  }

  get condition() {
    return this.attributes.condition || 'other';
  }

  toString() {
    const { focus, type } = this.attributes;
    return compact([
      `${this.prefix}${this.condition}.${this.source}`,
      type,
      focus,
    ]).join('/');
  }
}
